/**
 * description:
 * Reusable "blob hero" band for the top of a page — a colored band with a
 * page-specific hero graphic (blob + title, pre-composited together in
 * Figma so their real relative sizing/position is preserved exactly).
 * The blob is two overlapping circles, symmetric top and bottom, so the
 * graphic's natural height includes a mirrored bottom scallop that isn't
 * meant to show — `cropHeight` (out of the source SVG's viewBox height)
 * cuts it off just below the title. Image, crop, and band color are all
 * supplied per page since each page's hero design differs.
 */
import { Box, Typography } from "@mui/material";

const PageHero = ({
  image,
  viewBoxWidth,
  viewBoxHeight,
  cropHeight,
  bandColor,
  accessibleTitle,
  subtitle,
  subtitleColor,
  pt = { xs: "94px", sm: "92px", md: "106px", lg: "116px" },
  pb,
  width = { xs: "94vw", sm: "620px", md: "760px" },
  imageScale = 1,
}) => {
  return (
    <Box sx={{ bgcolor: bandColor, pt, pb }}>
      <Box
        component="h1"
        sx={{
          position: "relative",
          m: 0,
          mx: "auto",
          width,
          aspectRatio: `${viewBoxWidth} / ${cropHeight}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: `${imageScale * 100}%`,
            aspectRatio: `${viewBoxWidth} / ${cropHeight}`,
            overflow: "hidden",
          }}
        >
          <Box
            component="img"
            src={image}
            alt=""
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              aspectRatio: `${viewBoxWidth} / ${viewBoxHeight}`,
              height: "auto",
            }}
          />
        </Box>
        <Box
          component="span"
          sx={{ position: "absolute", width: "1px", height: "1px", overflow: "hidden", clip: "rect(0 0 0 0)", whiteSpace: "nowrap" }}
        >
          {accessibleTitle}
        </Box>
      </Box>

      {subtitle && (
        <Typography variant="body1" sx={{ color: subtitleColor, maxWidth: "620px", mx: "auto", mt: { xs: "28px", md: "36px" }, px: "20px", textAlign: "center" }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageHero;
